import { z } from 'zod'

// per-user defaults that let a linked Telegram chat record an expense by sending a bare number.
// stored as a single UserSettings value under UserSettingKey.TELEGRAM_QUICK_EXPENSE_DEFAULTS.
// both ids are required — without an account and a category the bot has nothing to create.
export const telegramQuickExpenseDefaultsSchema = z.object({
  defaultAccountId: z.string().guid(),
  defaultCategoryId: z.string().guid(),
})

export type TelegramQuickExpenseDefaultsDto = z.infer<typeof telegramQuickExpenseDefaultsSchema>
